const componentStyles = (theme) => ({
  cardRoot: {
    background:
      "linear-gradient(180deg, hsla(80, 100%, 35%, 1) 35%, hsla(89, 34%, 38%, 1) 100%)!important",
  },
  typographyH6: {
    color: theme.palette.gray[400],
    marginBottom: 0,
    letterSpacing: "2px",
    textTransform: "uppercase",
  },
  typographyH1: {
    color: theme.palette.white.main,
    display: "flex",
    justifyContent: "space-between",
  },
  typographyH3: {
    color: theme.palette.white.main,
    display: "block",
  },
  boxImg: {
    verticalAlign: "center",
    borderStyle: "none",
    maxWidth: "48px"
  },
  afterDash: {
    "&:not(:last-child):after": {
      content: "'-'",
      flex: "1 1 auto",
      textAlign: "center",
      position: "relative",
      left: "-2px",
    },
  },
});

export default componentStyles;
